import { CUSTOMER_API_URL } from '../config';

/**
 * POST /cart/checkout-url
 *
 * Sends the local cart lines to the backend, which creates a Shopify cart via
 * the Storefront API and returns the checkout URL.
 *
 * Throws a descriptive Error on non-2xx responses.
 */
export async function fetchCheckoutUrl(
  lines: Array<{
    variantId: number;
    quantity: number;
    properties: Record<string, string>;
  }>,
  rfsn?: string
): Promise<{ checkoutUrl: string; cartId: string }> {
  const response = await fetch(`${CUSTOMER_API_URL}/cart/checkout-url`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      lines: lines.map(item => ({
        variantId: String(item.variantId),
        quantity: item.quantity,
        attributes: Object.entries(item.properties).map(([key, value]) => ({
          key,
          value
        }))
      })),
      ...(rfsn && { rfsn })
    })
  });

  if (!response.ok) {
    const json = (await response.json().catch(() => ({}))) as {
      error?: string;
    };
    throw new Error(
      json.error || `Checkout request failed (${response.status})`
    );
  }

  const json = (await response.json()) as {
    checkoutUrl: string;
    cartId: string;
  };
  return { checkoutUrl: json.checkoutUrl, cartId: json.cartId };
}
